module.exports = __webpack_public_path__ + "img/checklist.7b168fed.svg";